import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, Children, isValidElement, useContext, cloneElement } from 'react';
import { TableContext } from './context.js';
import { useTableVirtualizer } from './useTableVirtualizer.js';
import { s as styles } from './table-CLlr1zNv.js';
import '@tanstack/react-virtual';

const TableBody = ({ 'data-qa': dataQa = 'table-body', children, }) => {
    const ref = useRef(null);
    const childArray = Children.toArray(children).filter((e) => isValidElement(e));
    const { fixedSize } = useContext(TableContext);
    const virtualizer = useTableVirtualizer({
        count: childArray.length,
        isScrollContainer: !!fixedSize,
        tableBodyRef: ref,
    });
    const items = virtualizer.getVirtualItems();
    const [paddingTop, paddingBottom] = items.length > 0
        ? [
            Math.max(0, items[0].start - virtualizer.options.scrollMargin),
            Math.max(0, virtualizer.getTotalSize() - (items[items.length - 1].end - virtualizer.options.scrollMargin)),
        ]
        : [0, 0];
    return (jsxs("tbody", { ref: ref, className: styles.body, "data-qa": dataQa, children: [paddingTop > 0 && jsx("tr", { style: { height: paddingTop } }), virtualizer.getVirtualItems().map((virtualItem) => {
                return cloneElement(childArray[virtualItem.index], {
                    key: virtualItem.key,
                    'data-index': virtualItem.index,
                    ref: virtualItem.measureElement,
                    measure: virtualItem.measureElement,
                });
            }), paddingBottom > 0 && jsx("tr", { style: { height: paddingBottom } })] }));
};

export { TableBody };
//# sourceMappingURL=TableBody.js.map
